import './entity-select.scss'

import { DataStore } from '@skinsoft/data-store';
import { DATASTORES_FROM_TYPE, ThesaurusDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import bModal from 'bootstrap-vue/es/components/modal/modal';
import { first } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { getTranslatedString } from '../localized-string';

@Component({
    components: {

    },
    props: ['type', 'modalTitle', 'modalPlaceholder', 'startValue', 'readonly', 'thesaurusIdentifier', 'filter', 'esPath'],
    template: require('./entity-select.html')
})
export class EntitySelect extends ReactiveVue {

    public type: string;
    public startValue: string;
    public modalTitle: string;
    public modalPlaceholder: string;
    public readonly: string;
    public thesaurusIdentifier: string;
    public filter: string;
    public esPath: string;
    public locale: string;

    public $refs: {
        modal: bModal
    }

    private filterText = "";
    private currentPageNumber: number = 1;
    private nbPages: number = 1;

    private titles: any[] = [];
    private totalSize: number = 0;
    private selectedTitle: any = { title: "" };

    private dataStore: DataStore;
    private $thesaurusDataStore: ThesaurusDataStore;

    private async subscribe() {
        if (this.dataStore) {
            this.unsubscribeFrom('entities-subscription')
            const locale = this.$i18n.locale;

            // Extra parameters when used to display thesaurus data or collaborator filtering
            let defaultFilter = ""
            let esPath = ""
            if (this.filter && this.esPath) {
                defaultFilter = this.filter;
                esPath = this.esPath;
            }

            if (this.thesaurusIdentifier) {
                const thesaurus = await this.$thesaurusDataStore.fetchOne(this.thesaurusIdentifier)
                    .pipe(first()).toPromise()
                defaultFilter = thesaurus.id;
                esPath = "thesaurusTermSkin.thesaurus.ref";
            }

            this.subscribeTo(
                this.dataStore.searchTitles([this.type], this.filterText, this.currentPageNumber - 1, defaultFilter, 5, undefined, esPath, this.locale)
                    .pipe(
                        first(),
                    )
                , (
                    data => {
                        this.titles = data.results.map(
                            title => {
                                return (
                                    {
                                        id: title.id,
                                        text: getTranslatedString(title.genericEntityTitle, locale),
                                    })
                            }
                        )
                        this.totalSize = data.totalSize;
                        const extraPage = data.totalSize % 5 > 0 ? 1 : 0;
                        this.nbPages = Math.floor(data.totalSize / 5) + extraPage;
                    }
                )
                ,
                'entities-subscription')
        }
    }

    private openModal() {
        this.$refs.modal.show()
    }

    private validateSelection() {
        this.$emit('entity-selected', this.selectedTitle)
        this.$refs.modal.hide()
    }
    private decrementPageNumber() {
        const newPage = this.currentPageNumber - 1;
        if (newPage >= 1) {
            this.currentPageNumber = newPage;
        }
    }

    private incrementPageNumber() {
        const newPage = this.currentPageNumber + 1;
        if (newPage <= this.nbPages) {
            this.currentPageNumber = newPage;
        }
    }

    private onModalClose() {
        this.subscribeToStartValue();
        this.$refs.modal.hide()
    }

    private subscribeToStartValue() {
        if (this.dataStore) {
            this.unsubscribeFrom('start-value-subscription')
            this.subscribeTo(
                this.dataStore.searchTitle([this.type], this.startValue)
                    .pipe(first())
                ,
                data => {
                    if (data.totalSize > 0) {
                        this.selectedTitle = { text: getTranslatedString(data.results[0].genericEntityTitle, this.locale) }
                    }
                }
                ,
                'start-value-subscription'
            )
        }
    }

    @Watch('filterText', { immediate: true, deep: true })
    private onFilterTextChange() {
        this.subscribe()
    }

    @Watch('currentPageNumber')
    private onCurrentPageNumberChange() {
        this.subscribe();
    }

    @Watch('startValue', { immediate: true })
    private onStartValueChange() {
        if (this.startValue) {
            this.subscribeToStartValue()
        }
    }

    @Watch('type', { immediate: true })
    private onTypeChange() {
        // Retrieving the right datastore adapted to the entity type
        this.dataStore = DATASTORES_FROM_TYPE[this.type].getInstance();
        if (this.startValue) {
            this.subscribeToStartValue()
        }
        this.subscribe();
    }

}